<style lang="stylus">
    .aiImage-rightcontent
        position absolute
        background-color white
        border 0.5px solid rgba(0, 0, 0, 0.04)
        box-shadow $box-shadow
        border-radius 8px
        overflow hidden
    .ft-aiImage-expand
        width 328px
        padding 16px
        display flex
        flex-wrap wrap
        column-gap 8px
        row-gap 8px
        .stylebox-item
            position relative
            width 68px
            height 68px
            border-radius 8px
            box-shadow 0px 0px 0px 0px rgba(0, 0, 0, 0.25)
            cursor pointer
            user-select none
            img
                width 100%
                height 100%
                border-radius 8px
            .stylebox-item-text
                position absolute
                bottom 0
                display flex
                justify-content center
                align-items center
                width 100%
                height 22px
                background rgba(0, 0, 0, 0.30)
                backdrop-filter blur(4px)
                border-radius 0 0 8px 8px
                p
                    font-size 10px
                    color #fff
                    textOverflow()
            &:hover::before
                opacity 0
            &::before
                position absolute
                top 0
                bottom 0
                left 0
                right 0
                content ""
                background-color rgba(0, 0, 0, .15)
                opacity 1
                border-radius 8px
                transition opacity .3s linear
</style>

<template>
    <div>
        <MenuList
            @mouseover.stop
            :menuList="AiContentList"
            @handleClicks="handleClicks(...arguments)"
            @handleMouseenter="handleMouseenter(...arguments)"
        ></MenuList>
        <!-- sub menus -->
        <div v-show="showMenu == 'imgStyle'" ref="imgStyle" class="aiImage-rightcontent" @mousedown.stop>
            <div class="ft-aiImage-expand" @mouseleave="showMenu = null">
                <div
                    class="stylebox-item"
                    :class="{ active: activeId == item.id }"
                    v-for="item in styleList"
                    @click="handleClick(item.id)"
                    :title="lang == 'zh' ? item.name : item.name_en"
                >
                    <img :src="item.img_url" alt="" />
                    <div class="stylebox-item-text">
                        <p>{{ lang == "zh" ? item.name : item.name_en }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";
    import { urls } from "@/public/utils/env.js";
    import { dataURLtoBlob } from "@/public/utils/tool.js";
    import axios from "axios";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class AiMenuList extends Vue {
        showMenu = "";

        get AiContentList() {
            let list = [
                {
                    key: "imgStyle",
                    label: this.$t("replace"),
                    img: "ai-img-replace",
                    expand: true,
                },
                // { key: "mindmapArrange", label: this.$t("mindmapArrange"), img: 'ai-mindmap-arrange', disabled: !this.isMMShape },
            ];
            return { list };
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            // prettier-ignore2
            let clickEvents = new Map([["mindmapArrange", () => {}]]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
            this.closeContext();
        }
        toRightAi() {
            this.$bus.$emit("showAIPanel", true);
        }
        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            if (["imgStyle"].includes(key)) {
                this.showMenu = key;
                let initPosition = (ref) => {
                    this.$nextTick(() => {
                        let parentEle = <HTMLElement>event.target;
                        ref.style.left = parentEle.offsetWidth + 15 + "px";
                        ref.style.top = parentEle.offsetTop + "px";
                    });
                };
                let mouseEvents = new Map([
                    [
                        "imgStyle",
                        () => {
                            let ref = this.$refs.imgStyle;
                            initPosition(ref);
                        },
                    ],
                ]);
                const mEvent = mouseEvents.get(key);
                mEvent && mEvent();
            } else {
                this.showMenu = "";
            }
        }
        closeContext() {
            this.$store.commit("closeContext");
        }

        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        styleList = [];
        activeId = -1;

        get userInfo() {
            return this.$store.getters.apiParam;
        }
        aiWorking = false;
        getStyleList() {
            if (this.styleList.length > 0) return;
            const url = `${urls.edrawmaxApi}/api/ai/draw/styles`;
            axios
                .get(url, {
                    params: {
                        style_key: "photo_change",
                    },
                })
                .then((res) => {
                    this.styleList = res.data.data.list.map((item, index) => {
                        return {
                            id: index,
                            ...item,
                        };
                    });
                });
        }

        handleClick(id) {
            this.showMenu = null;
            this.closeContext();
            this.activeId = id;
            const item = this.styleList[id];
            const data = {
                image: "",
                cfg_scale: item.cfg_scale,
                denoising_strength: item.denoising_strength,
                model: item.model ? item.model : 3,
                super: 1,
                style: item.name,
            };
            this.start(data);
        }

        loadImage(data) {
            data.image = window["_view"].getImageMediaBlob();
            let formData = new FormData();
            let keys = Object.keys(data);
            for (let name of keys) {
                formData.append(name, data[name]);
            }
            return Promise.resolve(formData);
        }

        async startTask(data: object, callback: Function) {
            const aiUrl = `${urls.edrawmaxApi}/api/ai`;
            const hasImage = data.hasOwnProperty("image");
            hasImage && (data = await this.loadImage(data));
            const order = await axios.post(`${aiUrl}/draw/start`, data, {
                headers: {
                    Authorization: `Bearer ${this.userInfo.token}`,
                },
            });
            const polling = () => {
                return axios.get(`${aiUrl}/draw/status`, {
                    headers: {
                        Authorization: `Bearer ${this.userInfo.token}`,
                    },
                });
            };
            const getImage = (order: string) => {
                return axios.get(`${aiUrl}/draw/task`, {
                    headers: {
                        Authorization: `Bearer ${this.userInfo.token}`,
                    },
                    params: {
                        task_id: order,
                    },
                });
            };

            let timer = setInterval(async () => {
                let interval = await polling();
                if (interval.data.data == "finished") {
                    clearInterval(timer);
                    const result = await getImage(order.data.data);
                    callback(result.data.data);
                }
            }, 500);
            const shutDown = () => {
                clearInterval(timer);
            };
            return shutDown;
        }

        start(data: object) {
            // this.replaceImgToPageTest();
            if (this.aiWorking) return;
            window["_view"].AISelTool(true);
            this.aiWorking = true;
            const callback = (result: any) => {
                this.$bus.$emit("refreshAIPoint");
                this.replaceImgToPage(result).then(() => {
                    this.aiWorking = false;
                    window["_view"].AISelTool();
                });
            };
            this.startTask(data, callback);
        }

        replaceImgToPage(result) {
            const url = result.image_url[0];
            return axios
                .get(url, {
                    responseType: "blob",
                })
                .then((res) => {
                    const fileName = (decodeURIComponent(url).match(/^.*[/](.*)/) && decodeURIComponent(url).match(/^.*[/](.*)/)[1]) || "";
                    const file = new File([res.data], fileName);
                    window["_view"].changeCurrentPicture(file);
                });
        }
        replaceImgToPageTest() {
            const url =
                "https://edrawcloudpubliccn.oss-cn-shenzhen.aliyuncs.com/ai-img%2FaiImage%2Fres%2F%E4%BA%BF%E5%9B%BEAI%E7%BB%98%E5%9B%BE_79161818_0.jpeg?Expires=1691997583&OSSAccessKeyId=LTAI4G75vqCJvXnaDfWxj3Yq&Signature=kl1Zr%2Bo0%2FROoo4a7by%2FEHn2Di8Y%3D";
            return axios
                .get(url, {
                    responseType: "blob",
                })
                .then((res) => {
                    const fileName = (url.match(/^.*[/](.*)/) && url.match(/^.*[/](.*)/)[1]) || "";
                    const file = new File([res.data], fileName);
                    window["_view"].changeCurrentPicture(file);
                });
        }

        created() {}
        mounted() {
            this.getStyleList();
        }
    }
</script>

<i18n>
{
    "zh": {
        "replace": "换风格"
    },
    "en": {
        "replace": "Change Style"
    },
    "de": {
        "replace": "Stil ändern"
    },
    "es": {
        "replace": "Cambiar estilo"
    },
    "fr": {
        "replace": "Modifier le style"
    },
    "it": {
        "replace": "Modifica stile"
    },
    "jp": {
        "replace": "スタイルを変更"
    },
    "pt": {
        "replace": "Alterar estilo"
    },
    "tw": {
        "replace": "變更樣式"
    }
}
</i18n>
